const getStringAsSpan = (text: string, className?: string) => {
  return `<span className='${ className }'>${ text }</span>`
}

export { getStringAsSpan };
